import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_BlurFaceInPhoto = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/blur-face-in-photo',
			name: 'Blur a Face in a Picture — AI-Powered Tool | Lift',
			description:
				'Blur a face in a photo with precision. Protect identities, remove bystanders, or hide sensitive details online. Try Lift.',
			url: 'https://liftapp.ai/blur-face-in-photo',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/blur-face-in-photo#product' },
				{ '@id': 'https://liftapp.ai/blur-face-in-photo#howto' },
				{ '@id': 'https://liftapp.ai/blur-face-in-photo#benefits' },
				{ '@id': 'https://liftapp.ai/blur-face-in-photo#faq' },
				{ '@id': 'https://liftapp.ai/blur-face-in-photo#why-lift' },
				{ '@id': 'https://liftapp.ai/blur-face-in-photo#explore-tools' },
				{ '@id': 'https://liftapp.ai/blur-face-in-photo#all-in-one' },
			],
		},
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/blur-face-in-photo#product',
			name: 'Blur Face in Photo',
			description:
				'Blur a face in a photo with precision. Protect identities, remove bystanders, or hide sensitive details online.',
			url: 'https://liftapp.ai/blur-face-in-photo',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: 4.8,
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/blur-face-in-photo#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload your image',
					text: "Choose a photo from your device or take one using Lift's app",
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'Select the face or person',
					text: 'Tap a face, outline a person, or use the manual brush to mark the exact area you want obscured',
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Adjust the intensity',
					text: 'Control the strength of the face blur and preview the result before saving',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download and use',
					text: 'Download your image or publish it straight to your social feeds',
				},
			],
		},
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/blur-face-in-photo#benefits',
			name: "Who can benefit from Lift's face blur tool?",
			description:
				"Lift's face blur tool is ideal for content creators, marketers, small business owners, privacy-conscious users, and anyone who needs to hide faces or identities in photos.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Content creators — Direct visual attention by obscuring faces of unintended subjects in your photos and videos.',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Marketers & SMM managers — Publish event shots and user-generated content without exposing identifiable faces.',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Small business owners — Protect customer privacy in photos shared across your website and social channels.',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Privacy-Conscious Users — Blur someone out of a picture before posting to keep personal details off public feeds.',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'Casual Users — No editing skills needed — select a face, set the strength, and download a clean result.',
				},
			],
		},
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/blur-face-in-photo#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: "What is Lift's face blur tool?",
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Lift's face blur tool lets you blur a face in a picture with targeted control. Upload your photo, select the face or person to obscure, set the blur intensity, and download — no prior editing experience required.",
					},
				},
				{
					'@type': 'Question',
					name: "How does Lift's face blur tool work?",
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Upload your photo and choose your targeting method — face detection, person outline, or manual brush. Lift's AI isolates the selected area, applies the blur, and shows a real-time preview so you can fine-tune the result before downloading.",
					},
				},
				{
					'@type': 'Question',
					name: 'Will it keep hair, edges, and fine details?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Yes. Lift's face blur tool uses advanced edge detection to preserve delicate elements like hair, fur, shadows, and soft textures — so you get clean, natural-looking results without manual touch-ups.",
					},
				},
				{
					'@type': 'Question',
					name: 'Can I download the results without a watermark?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Absolutely. All images generated or edited in Lift can be exported without watermark when you're on the Pro plan. Download them in high-res PNG or JPG — ready for social media, print, ads, or e-commerce.",
					},
				},
			],
		},
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/blur-face-in-photo#why-lift',
			name: "Why Lift's face blur tool stands out",
			description:
				"Lift's face blur tool combines professional-grade AI, ease of use, and affordability — making it a trusted choice for millions of users worldwide.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'High-quality results',
					description:
						'AI-powered technology delivers professional-grade visuals every time',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Intelligent rendering',
					description:
						'AI tailors the effect to the scene and subject for optimal results',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description: 'Available on iOS, Android, and Web for seamless access',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly designers with an affordable and intuitive tool',
				},
			],
		},
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/blur-face-in-photo#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},
		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/blur-face-in-photo#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in/?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in/?auto_login=true`,
				},
			],
		},
		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Blur Face in Photo',
					item: 'https://liftapp.ai/blur-face-in-photo',
				},
			],
		},
	],
};
